<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" hide-details option="Last quarter"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('HST Return Adjustments', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsOntarioHST',
  mixins: [printHtml],
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      hstAdjustment: null
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'HST return adjustments')
//    this.refresh();
  },

  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsOntarioHST($from:Date!, $to:Date!) {
                                             hstAdjustment(from:$from,to:$to) {
                                               licensee {reported,actual,hst}
                                               sop {reported,actual,hst}
                                               ontario {reported,actual,hst}
                                             }
                                           }`,
                                           {from:this.from,to:this.to});
      if (!results.error)
        this.hstAdjustment = results.data.hstAdjustment;
      this.loading = false;
    },

    report() {
      if (!this.hstAdjustment)
        return '';
      return `<style>
                @page {size:portrait}
                .report-hst {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                .report-hst th {height:36px;padding:0 16px;vertical-align:middle}
                .report-hst td {height:36px;padding:0 16px;vertical-align:middle}
                .report-hst .title {font-size:18px;text-transform:uppercase}
                .report-hst .sup-title {font-weight:normal;font-size:22px}
                .report-hst .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                .report-hst .header th {border-bottom:1px solid #000;margin-bottom:20px}
                .report-hst .text-left {text-align:left}
                .report-hst .text-right {text-align:right}
                .report-hst .total-row {font-weight:bold}
                .report-hst .indent {text-indent:20px}
              </style>
              <table class="report-hst">
                <thead>
                  <tr>
                    <th colspan="7" class="sup-title">${this.$store.getters.company.name}</th>
                  </tr>
                  <tr>
                    <th colspan="7" class="title">HST return adjustments</th>
                  </tr>
                  <tr>
                    <th colspan="7" class="sub-title">${this.dateDisplay}</th>
                  </tr>
                  <tr class="header">
                    <th width="55%" class="text-left">Line</th>
                    <th width="15%" class="text-right">Reported</th>
                    <th width="15%" class="text-right">Actual</th>
                    <th width="15%" class="text-right">Adjustment</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left" colspan="4">Line 101: Sales and other revenue</td>
                  </tr>
                  <tr>
                    <td class="text-left indent">LCBO spirit sales to licensees</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.reported)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.actual)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.actual-this.hstAdjustment.licensee.reported)}</td>
                  </tr>
                  <tr>
                    <td class="text-left indent">LCBO spirit sales to SOP</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.sop.reported)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.sop.actual)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.sop.actual-this.hstAdjustment.sop.reported)}</td>
                  </tr>
                  <tr>
                    <td class="text-left indent">Ontario taxable distribution</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.ontario.reported)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.ontario.actual)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.ontario.actual-this.hstAdjustment.ontario.reported)}</td>
                  </tr>
                  <tr :class="dark ? 'total-row-dark' : 'total-row'">
                    <td class="text-left"></td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.reported+this.hstAdjustment.sop.reported+this.hstAdjustment.ontario.reported)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.actual+this.hstAdjustment.sop.actual+this.hstAdjustment.ontario.actual)}</td>
                    <td class="text-right">${this.dollars((this.hstAdjustment.licensee.actual-this.hstAdjustment.licensee.reported)+(this.hstAdjustment.sop.actual-this.hstAdjustment.sop.reported)+(this.hstAdjustment.ontario.actual-this.hstAdjustment.ontario.reported))}</td>
                  </tr>

                  <tr>
                    <td class="text-left" colspan="4">Line 103: GST/HST collected or collectible</td>
                  </tr>
                  <tr>
                    <td class="text-left indent">LCBO spirit sales to licensees</td>
                    <td class="text-right">${this.dollars(0)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.hst)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.hst)}</td>
                  </tr>
                  <tr>
                    <td class="text-left indent">LCBO spirit sales to SOP</td>
                    <td class="text-right">${this.dollars(0)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.sop.hst)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.sop.hst)}</td>
                  </tr>
                  <tr>
                    <td class="text-left indent">Ontario taxable distribution</td>
                    <td class="text-right">${this.dollars(0)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.ontario.hst)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.ontario.hst)}</td>
                  </tr>
                  <tr :class="dark ? 'total-row-dark' : 'total-row'">
                    <td class="text-left"></td>
                    <td class="text-right">${this.dollars(0)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.hst+this.hstAdjustment.sop.hst+this.hstAdjustment.ontario.hst)}</td>
                    <td class="text-right">${this.dollars(this.hstAdjustment.licensee.hst+this.hstAdjustment.sop.hst+this.hstAdjustment.ontario.hst)}</td>
                  </tr>
                </tbody>
              </table>`;
    },
    dollars(value) {
      return this.$currency(value);
    },
    exportCSV() {
      const lines = [ `"${this.$store.getters.company.name}",,,`,
                      `"HST return adjustments",,,`,
                      `"${this.dateDisplay}",,,`,
                      `"Line","Reported","Actual","Adjustment"`,
                      `"Line 101: Sales and other revenue",,,`,
                      `"LCBO spirit sales to licensees","${this.hstAdjustment.licensee.reported}","${this.hstAdjustment.licensee.actual}","${this.hstAdjustment.licensee.actual-this.hstAdjustment.licensee.reported}"`,
                      `"LCBO spirit sales to  SOP","${this.hstAdjustment.sop.reported}","${this.hstAdjustment.sop.actual}","${this.hstAdjustment.sop.actual-this.hstAdjustment.sop.reported}"`,
                      `"Ontario taxable distribution","${this.hstAdjustment.ontario.reported}","${this.hstAdjustment.ontario.actual}","${this.hstAdjustment.ontario.actual-this.hstAdjustment.ontario.reported}"`,
                      `,"${this.hstAdjustment.licensee.reported+this.hstAdjustment.sop.reported+this.hstAdjustment.ontario.reported}","${this.hstAdjustment.licensee.actual+this.hstAdjustment.sop.actual+this.hstAdjustment.ontario.actual}","${(this.hstAdjustment.licensee.actual-this.hstAdjustment.licensee.reported)+(this.hstAdjustment.sop.actual-this.hstAdjustment.sop.reported)+(this.hstAdjustment.ontario.actual-this.hstAdjustment.ontario.reported)}"`,
                      `"Line 103: GST/HST collected or collectible",,,`,
                      `"LCBO spirit sales to licensees","0","${this.hstAdjustment.licensee.hst}","${this.hstAdjustment.licensee.hst}"`,
                      `"LCBO spirit sales to SOP","0","${this.hstAdjustment.sop.hst}","${this.hstAdjustment.sop.hst}"`,
                      `"Ontario taxable distribution","0","${this.hstAdjustment.ontario.hst}","${this.hstAdjustment.ontario.hst}"`,
                      `,,"${this.hstAdjustment.licensee.hst+this.hstAdjustment.sop.hst+this.hstAdjustment.ontario.hst}","${this.hstAdjustment.licensee.hst+this.hstAdjustment.sop.hst+this.hstAdjustment.ontario.hst}"`,
                    ];

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'HST return adjustments.csv');
    }
  }
}
</script>